var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"brand"},[_c('router-link',{attrs:{"exact":"","to":{ name: _vm.routeName }}},[_c(_vm.logoComp,{tag:"Component",attrs:{"height":"26","alt":_vm.logoAlt,"title":_vm.logoAlt}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }